import React from 'react';
import classNames from 'classnames';
import styles from './volumeDiscount.scss';
import { IScalePrice, IPrice, IQuantityUnit } from '../../stores/types';
import { ILocalization } from '../../types';
import * as helper from '../../helper/html-helper';

function VolumeDiscount(props: IVolumeDiscount) {
    const { scalePrices, scalePriceTexts, basicPrice, activePrice, articleCount, quantityUnit, withVat,
        onArticleCountChange, localization } = props;
    const getPriceValue = React.useCallback((price: IPrice): number => {
        return withVat ? price.grossValue : price.netValue;
    }, [withVat]);
    const trackingLabel = 'bulk-discount-box_';

    if (!Array.isArray(scalePrices) || scalePrices.length === 0) {
        return null;
    }

    return (
        <div className={styles.vd_root}>
            <div className={styles.vd_title}>{helper.decodeHTML(localization.generalL10n.volumeDiscountText)}</div>
            <div className={styles.vd_container}>
                {scalePrices.map((scalePrice, index) => {
                    const isActiveTile = getPriceValue(scalePrice.price) === getPriceValue(activePrice);
                    const discount = (((basicPrice.grossValue / scalePrice.price.grossValue) - 1) * 100).toFixed(0);
                    const lineColored = articleCount >= scalePrice.quantity;
                    const unit = scalePrice.quantity > 1 ? quantityUnit.plural : quantityUnit.singular;
                    let prePriceString = scalePriceTexts[index][0].trim();
                    if (prePriceString[prePriceString.length -1] === ':') {
                        prePriceString = prePriceString.slice(0, prePriceString.length -1);
                    }

                    return (
                        <div
                            key={scalePrice.price.grossValue + index}
                            className={styles.vd_element}
                            data-testid={trackingLabel + index}
                            data-semantic-id={trackingLabel + index}
                            onClick={() => onArticleCountChange(scalePrice.quantity)}
                        >
                            <div className={classNames(styles.vd_tile, styles.active, styles.status_yellow, {
                                [styles.isActive]: isActiveTile,
                                [styles.border_yellow]: index === 0,
                                [styles.border_green]: index > 0,
                            })}
                            >
                                <div>{prePriceString}</div>
                                <div className={styles.bold_text}>
                                    {helper.decodeHTML(localization.generalL10n.savingsText)}
                                </div>
                                <div className={classNames({
                                        [styles.bold_text]: index > 0,
                                        [styles.green_text]: index > 0,
                                    })}>{discount} %/{unit}</div>
                            </div>
                            <div className={classNames(styles.vd_status_line, {
                                [styles.line_yellow]: lineColored && index === 0,
                                [styles.line_green]: lineColored && index > 0,
                            })}></div>
                        </div>
                    )}
                )}
            </div>
        </div>
    )
}

interface IVolumeDiscount {
    scalePrices: IScalePrice[];
    scalePriceTexts: string[][];
    basicPrice: IPrice;
    activePrice: IPrice;
    articleCount: number;
    quantityUnit: IQuantityUnit;
    withVat: boolean;
    onArticleCountChange(newCount: number): void,
    localization: ILocalization;
}

export default VolumeDiscount;

